import { FunctionComponent, ReactElement } from 'react';

import { Loader } from '../../atoms/loader';

import { $LoaderContainer } from './FloatingLoader.styles';

interface BaseLoaderProps {
  size?: string;
  customLoader?: ReactElement;
}

export const FloatingLoader: FunctionComponent<BaseLoaderProps> = ({
  size = '32px',
  customLoader,
}) => {
  return (
    <$LoaderContainer $size={size}>
      {customLoader || <Loader size={size} />}
    </$LoaderContainer>
  );
};
